export enum AcademyAdministratorOperation{
    CREATE = 'Create',
    UPDATE = 'Update',
    DELETE = 'Delete',
    FIND = 'Find',
    SELECT = 'Select',
    BULK_UPDATE = 'BulkUpdate'
}